import React, { Component } from 'react';
import LazyHydrate from 'react-lazy-hydration';
import { JsonLd } from 'react-schemaorg';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import absoluteUrl from 'helpers/absoluteUrl';
import { daysDifAndTime, difDays } from 'helpers/formatDate';
import Link from 'components/link';
import { Thumb } from 'components/image';
import Row, { Col } from 'components/row';
import Icon, { iconTypes } from 'components/icon';

import linksDomik from 'src-sites/domik/links';

import translates from './articles-i18n';

import 'styles/domik/mixins/_views-article.scss';

const bemClasses = new Bem('viewArticle');

@I18nHoc(translates())
export default class TileArticle extends Component {
  static propTypes = {
    className: PropTypes.string,
    seoData: PropTypes.shape({}),
    dataMods: PropTypes.string,
    device: PropTypes.string,
    data: PropTypes.shape({})
  };

  render() {
    const { className, dataMods = {}, seoData } = this.props;
    const data = get(this, 'props.data') || get(this, 'props.object') || {};
    const {
      image: img_main, name, comments, time_to_publish, date_ed, landing_url
    } = data;
    const header = get(seoData, 'header') ? seoData.header : name;
    const image = typeof img_main === 'string' ? { id: img_main } : img_main;
    const imageArticle = { ...image, alt: header, title: header };
    const builderProps = {
      title: header,
      url: landing_url
    };
    const commentsCount = get(comments, 'count');

    return (
      <LazyHydrate
        whenVisible
        style={{}}
        {...bemClasses(null, dataMods, className)}
      >
        <article {...bemClasses('content')}>
          <Row {...bemClasses('row', 'img')}>
            <Col {...bemClasses('col', 'img')} allPr={0}>
              <div {...bemClasses('imgContainer')}>
                <div {...bemClasses('img')}>
                  <Link
                    {...bemClasses('link', 'fill')}
                    builder={linksDomik.sectionLanding}
                    builderProps={builderProps}
                    children={<span />}
                  />
                  <Thumb
                    {...bemClasses('imgPic')}
                    image={imageArticle}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <header {...bemClasses('title')}>
            <h3>
              <Link
                {...bemClasses('link', 'toArticle')}
                builder={linksDomik.sectionLanding}
                builderProps={builderProps}
              >
                <span {...bemClasses('linkContent')}>
                  <span {...bemClasses('text')} children={header} />
                </span>
              </Link>
            </h3>
          </header>
          <div {...bemClasses('item', 'time')}>
            <time
              {...bemClasses('time')}
              dateTime={time_to_publish}
              children={daysDifAndTime.call(this, time_to_publish)}
            />
          </div>
          {!!commentsCount &&
            <div {...bemClasses('item', 'commentCount')}>
              <div {...bemClasses('commentCount')}>
                <div {...bemClasses('btn', 'toComment')}>
                  <span {...bemClasses('btnContent')}>
                    <Icon {...bemClasses('icon')} type={iconTypes.commentRound} />
                    <span {...bemClasses('text')} children={get(comments, 'count') || '0'} />
                  </span>
                </div>
              </div>
            </div>
          }
          <JsonLd
            item={{
              '@context': 'https://schema.org',
              '@type': 'Article',
              mainEntityOfPage: absoluteUrl(landing_url),
              image: get(image, 'id') ? absoluteUrl(`/images/thumb/full/${image.id}`) : null,
              headline: header || null,
              name: header || null,
              // description: annotation || null,
              datePublished: time_to_publish || null,
              dateModified: date_ed || null
            }}
          />
        </article>
      </LazyHydrate>
    );
  }
}
